import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input, Form, Icon, Checkbox } from "semantic-ui-react";
import { AppState } from "../../store/configureStore";
import { RedirectIfLoggedIn } from "../../components/RedirectIfLoggedIn";
import { localLoginRequest } from "../../actions/authentificationActions";
import { fetchAppStage } from "../../store/appStageReducer";
import logo from "./tscnet-logo.png";
//@ts-ignore
import Pdf from "../../documents/GDPR_Perun_Documentation_20240519.pdf";
//@ts-ignore
import UseStatementPdf from "../../documents/TSCNET_Services_GmbH_PERUN4V_Acceptable_Use_Statement_20240519.pdf";
import { toast } from "../..";
import { isLocalLoginEnabled } from "../../services/authenticationService";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { appStageToTitle } from "../../helpers/appStageHelper";
import "./Login.css";
import { emailRegex } from "../../helpers/loginHelper";

export const LocalLogin = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [usePolicyAccepted, setUsePolicyAccepted] = useState(false);
    const [title, setTitle] = useState("");
    const login = useSelector((state: AppState) => state.login);
    const stageState = useSelector((state: AppState) => state.appStage);
    const dispatch = useDispatch();
    const isEnabled = username.length > 0 && password.length > 0;
    const [localLoginEnabled, setLocalLoginEnabled] = useState<boolean>();

    useEffect(() => {
        isLocalLoginEnabled().then(enabled => {
            setLocalLoginEnabled(enabled);
            if (!enabled) navigate("/login");
        });
    }, [navigate]);

    useEffect(() => {
        fetchAppStage(dispatch);
    }, [dispatch]);

    useEffect(() => {
        try {
            const title = appStageToTitle(stageState.stage);
            setTitle(title);
            document.title = title;
        } catch (err) {
            toast("Unable to determine environment", false, 3000);
        }
    }, [stageState.stage]);

    const handleChange = (field: string, e: ChangeEvent<HTMLInputElement>) => {
        if (field === "username") setUsername(e.target.value);
        else setPassword(e.target.value);
    };

    const loginClick = () => {
        if (emailRegex.test(username)) {
            dispatch(localLoginRequest({ username, password }));
        } else {
            toast("Please enter a valid email address", false, 3000);
        }
    };

    // Stops the flash of the login component while isLocalLoginEnabled is being fetched
    if (!localLoginEnabled) return null;

    return (
        <div id="container-center-login" className="container-center">
            <RedirectIfLoggedIn />
            <div id="login-form-container">
                <img id="logo" src={logo} alt="Logo" />
                <h1 id="h1-login-a" className="tsc-blue">
                    {title}
                </h1>
                <Form id="form-login-a">
                    <Form.Field id="form-field-login-a">
                        <label id="label-username-login">Username</label>
                        <Input
                            id="username-a"
                            icon="user"
                            iconPosition="left"
                            placeholder="Username"
                            value={username}
                            onChange={handleChange.bind(null, "username")}
                        />
                    </Form.Field>
                    <Form.Field id="form-field-login-b">
                        <label id="label-password-login-a">Password</label>
                        <Input
                            id="password-a"
                            icon="lock"
                            type="password"
                            iconPosition="left"
                            placeholder="Password"
                            value={password}
                            onChange={handleChange.bind(null, "password")}
                        />
                    </Form.Field>
                    <div id="password-security-container">
                        <Link id="forgot-password" to="/forgot-password">
                            <Icon id="icon-login-b" name="unlock alternate" />
                            Forgot password?
                        </Link>
                        <p id="secure-connection-text">
                            <Icon id="icon-login-a" name="lock" />
                            secure connection
                        </p>
                    </div>

                    <p id="login-error-msg" className="warning-text">
                        {login.error}
                    </p>
                    <p id="acceptance-checkbox-login" className="acceptance-checkbox">
                        <Checkbox
                            id="checkbox-login-a"
                            fitted={false}
                            checked={usePolicyAccepted}
                            onChange={() => setUsePolicyAccepted(!usePolicyAccepted)}
                        />
                        <label id="label-login-b">
                            Read and accept the{" "}
                            <strong id="strong-login-a">
                                <a
                                    id="a-tscnetPolicy-login"
                                    href={UseStatementPdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    TSCNET Policy
                                </a>
                            </strong>{" "}
                            to be able to login
                        </label>
                    </p>
                    <p id="p-login-c">
                        <label id="label-information-login">
                            Information according to Art. 13 GDPR&nbsp;
                            <strong id="strong-login-d">
                                <a
                                    id="a-login-noopener"
                                    href={Pdf}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    here
                                </a>
                            </strong>
                        </label>
                    </p>
                    <Button
                        id="button-login-b"
                        fluid
                        content="Login"
                        primary
                        loading={login.currentlySending}
                        onClick={loginClick}
                        disabled={!isEnabled || !usePolicyAccepted}
                    />
                    <Button
                        id="button-login-c"
                        fluid
                        content="Back"
                        primary
                        onClick={() => navigate("/login")}
                    />
                </Form>
            </div>
        </div>
    );
};
